import React, { FC, useCallback } from "react";
import { trafficLight } from "../../theme";
import { ITag } from "../../types/types";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
    Paper, Tooltip, Grid, IconButton
} from "@material-ui/core";

import GetAppIcon from '@material-ui/icons/GetApp';
import NotesIcon from '@material-ui/icons/Notes';


import { toPng } from "html-to-image";
import downloadjs from "downloadjs";
import { CSVLink, CSVDownload } from "react-csv";

const useStyles = makeStyles({

    grid: {
        display: 'grid',
        gridTemplateColumns: 'max-content  repeat(24,1fr)',
        padding: '10px 10px',
        justifyContent: 'center',

    },

    item: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '1px solid lightgrey',
        
        fontSize: '12px',
        padding: '0px 2px',


    },
    item2: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        width: '17px',
        height: '17px',
        margin: '2px 0px',
        '&:hover': {
            transform: 'scale(1.0)',
            boxShadow: '0px 0px 5px 0px black',

        }
    },
    title: {
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',

        fontSize: '12px',
        padding: '0px 2px',

    },

    label: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '1px solid black',
        fontSize: '12px',
        padding: '10px 2px',
        borderTop: '1px solid black',
        borderRight: '1px solid black',
        // writingMode: 'vertical-rl',
        // WebkitTransform: 'rotate(180deg)',
        // whiteSpace: 'nowrap',


    },


    label2: {
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        borderTop: '1px solid black',
        padding: '10px 0px',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    overlap: {
        gridArea: '1 / 1 / 10 / 10',
        position: 'relative',
        ZIndex: '1',
    }

});

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
    },
}))(Tooltip);


interface IFMChartProps {
    investigations: any[][]
    tags: ITag[]
}


const HeatmapInvestigation: FC<IFMChartProps> = ({ investigations, tags }) => {

    const classes = useStyles();

    const subgroups: string[] = tags.map(tag => tag.name);

    const count_data = investigations.map(dam => {
        return dam.map(d => {
            // if d is an array
            if (Array.isArray(d)) {
                return d[1]
            } else {
                return d
            }
        })
    })

    const csvData = [['dam name', 'societal impact', ...subgroups], ...count_data]


    const setColor = (level: any, def: any) => {

        if (def === 0) {
            return 'white'
        }

        if (level === 1) {
            return trafficLight.cmred
        }
        if (level === 2) {
            return trafficLight.cmorange
        }
        if (level === 3) {
            return trafficLight.cmyellow
        }
        if (level === 4) {
            return trafficLight.cmgreen
        }
        if (level === 5) {
            return trafficLight.grey
        }

    }

    const setName = (level: any) => {

        if (level === 1) {
            return 'Very Strong'
        }
        if (level === 2) {
            return 'Strong'
        }
        if (level === 3) {
            return 'Weak'
        }
        if (level === 4) {
            return 'Very Weak'
        }
        if (level === 5) {
            return 'Undefined'
        }
    }

    const length = subgroups.length + 1;

    const grid_style = {
        gridTemplateColumns: 'max-content max-content repeat(' + length + ',1fr)'
    }

    const handleCaptureClick = useCallback(() => {

        const pricingTableElmt = document.querySelector<HTMLElement>('.inv-table')
        if (!pricingTableElmt) return;
        toPng(pricingTableElmt, { pixelRatio: 4, cacheBust: true })
            .then((dataUrl: any) => {
                downloadjs(dataUrl, 'investigations.png');
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])


    return (
        <>
            <div style={{ padding: "10px" }}>
                <Paper variant={"outlined"} className={'table-section.' + ' inv-table'}>
                    <Grid container>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            <p style={{ fontSize: "20px", position: 'relative', top: '-10px' }}>
                                <strong>Investigations</strong></p>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton aria-label="download" onClick={handleCaptureClick}>
                                <GetAppIcon />
                            </IconButton>

                            <CSVLink data={csvData} filename={"investigations.csv"}>
                                <IconButton aria-label="data">
                                    <NotesIcon />
                                </IconButton>
                            </CSVLink>

                        </Grid>
                    </Grid>
                    <div className={classes.grid} >
                        <div className={classes.title}></div>
                        <div className={classes.label} style={{borderLeft:'1px solid black'}}><b>Societal risk (live/year)</b></div>
                        {
                            subgroups.map(subgroup => {
                                return <div className={classes.label}>{subgroup}</div>
                            })
                        }
                        <div className={classes.label}><b>Total</b></div>
                        {
                            investigations.map(dam => {

                                let dam_name = ""

                                const element = dam.map((d, index) => {

                                    let left = ""
                                    let right = "1px solid lightgrey"

                                    if (index === 1) {
                                        left = "1px solid black"
                                        right = "1px solid black"
                                    }
                                    //
                                    if (index === subgroups.length + 1 || index === subgroups.length + 2) {
                                        right = "1px solid black"
                                    }

                                    if (index === 0) {
                                        dam_name = d
                                        return <div className={classes.title}>{d}</div>
                                    }
                                    if (index === 1) {
                                        return (<div className={classes.item} style={{
                                            borderLeft: left,
                                            borderRight: right,
                                            color: setColor(6, d[1])
                                        }}>
                                            {d}
                                        </div>)
                                    } else {
                                        return (
                                            <LightTooltip title={
                                                <div>
                                                    <b>{dam_name}</b> <br /> {setName(d)}
                                                </div>
                                            }>
                                                <div className={classes.item} style={{
                                                    borderLeft: left,
                                                    borderRight: right,
                                                    color: setColor(6, d[1])
                                                }}>
                                                    {d[1] !== ""
                                                        ? <div className={classes.item2}
                                                            style={{ backgroundColor: setColor(d[0], d[1]) }}>{d[1]}</div>
                                                        : ""}
                                                </div>
                                            </LightTooltip>
                                        )

                                    }
                                })

                                return element
                            })
                        }



                    </div>
                </Paper>

            </div>


        </>

    )

}


export default HeatmapInvestigation;